import CommonAPI from './CommonAPI.js';

import Logger from './Logger.js'
import CommonUtil from './CommonUtil.js'


export default {
  
  requestCode(phone, topicHash, func_ok, func_error) {
      if (!func_error) func_error = this._common_error

      return CommonAPI.instance().post(
        '/api/nominee/public/auth/send-code',
        {
          phone: phone,
          topicHash: topicHash
        },
        {})
        .then(res => func_ok(res.data))
        .catch((err) => func_error(err))
  },

  requestCodeForRecommend(phone, registerHash, func_ok, func_error) {
      if (!func_error) func_error = this._common_error

      return CommonAPI.instance().post(
        '/api/nominee/public/auth/send-code',
        {
          phone: phone,
          registerHash: registerHash
        },
        {})
        .then(res => func_ok(res.data))
        .catch((err) => func_error(err))
  },

  confirmCode(phone, authCode, topicHash, func_ok, func_error) {
    if (!func_error) func_error = this._common_error

    return CommonAPI.instance().post(
      '/api/nominee/public/auth/verify-code',
      {
        phone: phone,
        authCode: authCode,
        topicHash: topicHash
      },
      {})
      .then(res => func_ok(res.data))
      .catch((err) => func_error(err))
  },

  confirmCodeForRecommend(phone, authCode, registerHash, func_ok, func_error) {
    if (!func_error) func_error = this._common_error

    return CommonAPI.instance().post(
      '/api/nominee/public/auth/verify-code',
      {
        phone: phone,
        authCode: authCode,
        registerHash: registerHash
      },
      {})
      .then(res => func_ok(res.data))
      .catch((err) => func_error(err))
  },

      _common_error(err) {
        Logger.debug("error" + err)
        alert(CommonUtil.extractErrorMessage(err))
      },
      
}